var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import ParagraphsWithIcon from '@declaration/components/ParagraphsWithIcon.vue';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@shared/layout/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { ClaimTypeTrigram } from '@shared/types/api/claim';
const qualification = namespace('qualification');
let CompensationLowDeductible = class CompensationLowDeductible extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/refus-total.svg');
    }
    get isElectric() {
        return this.claimTypeTrigram === ClaimTypeTrigram.Electric;
    }
    get contents() {
        return this.isElectric
            ? [
                {
                    html: this.$tc('compensation.not_covered.deductible.description'),
                },
            ]
            : [
                {
                    html: this.$tc('compensation.not_covered.deductible.description'),
                },
                {
                    icon: 'mail',
                    html: this.$tc('compensation.confirmation.description.mail'),
                },
                {
                    html: this.$tc('compensation.not_covered.close'),
                },
            ];
    }
};
__decorate([
    qualification.State('typeTrigram')
], CompensationLowDeductible.prototype, "claimTypeTrigram", void 0);
CompensationLowDeductible = __decorate([
    Component({
        components: {
            ParagraphsWithIcon,
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.compensation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            goBack: null,
        },
    })
], CompensationLowDeductible);
export default CompensationLowDeductible;
